import { Routes, Route, Navigate } from "react-router-dom";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import useAccountHasEntitlement from "@common/hooks/useAccountHasEntitlement";
import { List } from "./List/List";
import { New } from "./New/New";
import { Edit } from "./Edit/Edit";
import { EntitlementBanner } from "../ProjectApprovalV1Mspa/EntitlementBanner";

const ProjectApprovalV2Mspa = () => {
  const { hasPrivilege } = usePrivilegeCheck();
  const { hasEntitlement } = useAccountHasEntitlement();

  if (!hasPrivilege("settings.project_approval", ["create", "manage"])) {
    return (
      <div className="p-3">You do not have access to Project Approval.</div>
    );
  }

  const entitlement = hasEntitlement("workflow-approval");

  return (
    <>
      {!entitlement && <EntitlementBanner />}
      <Routes>
        <Route index element={<List />} />
        <Route path="new" element={<New />} />
        <Route path=":id/edit" element={<Edit />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </>
  );
};

export default ProjectApprovalV2Mspa;
